import { render, staticRenderFns } from "./ClimateZonesSelecteds.vue?vue&type=template&id=055deee1&"
import script from "./ClimateZonesSelecteds.vue?vue&type=script&lang=js&"
export * from "./ClimateZonesSelecteds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports